// 📁 Archivo: src/pages/ReporteAvance.jsx

import { useEffect, useState } from 'react';
import axios from 'axios';
import { BarChart2 } from 'lucide-react';
import { getSafeToken } from '../utils/tokenHelper';

export default function ReporteAvance() {
  const [interacciones, setInteracciones] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const token = getSafeToken();
      try {
        const res = await axios.get('/api/progreso/usuario', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setInteracciones(res.data);
      } catch (err) {
        console.error('Error al obtener avance', err);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 flex items-center">
        <BarChart2 className="w-5 h-5 mr-2" />
        Reporte de Avance
      </h2>
      {interacciones.length === 0 ? (
        <p className="text-gray-600">Aún no hay interacciones registradas.</p>
      ) : (
        <table className="w-full border text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 border">Fecha</th>
              <th className="p-2 border">GPT</th>
              <th className="p-2 border">Tipo</th>
              <th className="p-2 border">Resultado</th>
              <th className="p-2 border">Detalle</th>
            </tr>
          </thead>
          <tbody>
            {interacciones.map((item, idx) => (
              <tr key={idx}>
                <td className="p-2 border">{new Date(item.fecha).toLocaleString()}</td>
                <td className="p-2 border">{item.gpt}</td>
                <td className="p-2 border">{item.tipo}</td>
                <td className="p-2 border">{item.resultado || '-'}</td>
                <td className="p-2 border">{item.detalle}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
